// Sticky Values
($ => {
    let mm = gsap.matchMedia();

    let blocks = gsap.utils.toArray(".ttr-sticky-values .wp-block-columns");

    blocks.forEach((block) => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: block,
                start: "top 50%",
                end: "bottom 50%",
                // pin: true,
                scrub: false, // change opacity immediately on trigger
                // markers: true,
                // toggleActions: "play none none none",
            }
        });
        tl.from(block, {
            opacity: 0.05,
            duration: 0.5
        });
    });

})(jQuery);
